<template>
  <div class="vue-plyr">
    <slot />
  </div>
</template>

<script>
export default {
  name: "VuePlyr",
  props: {
    options: { type: Object, default: () => ({}) }
  },
  mounted() {
    // Keep markup compatible; enhance with native controls if plyr is unavailable.
    const media = this.$el.querySelector("video, audio, iframe");
    if (media && !media.getAttribute("controls") && media.tagName !== "IFRAME") {
      media.setAttribute("controls", "controls");
    }
  }
};
</script>
